import { ReadyState } from "react-use-websocket";
export const Menulist = [
  {
    key: "dashboard",
    icon: "dashboard",
    path: "dashboard",
    title: "Dashboard",
  },
  {
    key: "client",
    icon: "client",
    path: "client",
    title: "Client",
  },
];
export const WEB_SOCKET_CONNECTION_STATUS = {
  [ReadyState.CONNECTING]: "Connecting",
  [ReadyState.OPEN]: "Open",
  [ReadyState.CLOSING]: "Closing",
  [ReadyState.CLOSED]: "Closed",
  [ReadyState.UNINSTANTIATED]: "Uninstantiated",
};
